import DateHandler from "@/composables/handlers/DateHandler";
import BaseModel from "./BaseModel";
import PaymentStatusDictionary from "@/dictionary/PaymentStatusDictionary";
import PaymentMethodDictionary from "@/dictionary/PaymentMethodDictionary";

/**
 * Payment 
 */
export default class Payment extends BaseModel{

  constructor({
    id,
    user,
    course_ids,
    status,
    reference_id,
    content,
    payment_id,
    payment_content,
    preference_data,
    payment_status,
    payment_method,
    items,
    is_approved,
    payer_name,
    payer_email,
    payment_link,
    product_type,
    created_at,
    updated_at,
  }) {
    super();
    
    this.paymentStatus = {
      CREATED: 1,
      APPROVED: 2,
      REFUSED: 3,
      EXPIRED: 4
    };

    this.paymentStatusLabel = {
      CREATED: 'created',
      APPROVED: 'approved',
      REFUSED: 'refused',
      EXPIRED: 'expired'
    };
    
    this.statusDictionary = new PaymentStatusDictionary();
    this.methodDictionary = new PaymentMethodDictionary();

    this.id = id || null;
    this.user = user || null;
    this.course_ids = course_ids.split(',') || null;
    this.status = status || null;
    this.reference_id = reference_id || null;
    this.content = content || null;
    this.payment_id = payment_id || null;
    this.payment_content = payment_content || null;
    this.payment_status = payment_status || null;
    this.payment_method = payment_method || null;
    this.items = items || null;
    this.is_approved = is_approved || null;
    this.payer_name = payer_name || null,
    this.payer_email = payer_email || null;
    this.payment_link = payment_link || null;
    this.product_type = product_type || 'course';
    this.created_at = created_at ? new Date(created_at) : null || null;
    this.updated_at = updated_at ? new Date(updated_at) : null || null;

    this.normalizeCourseIds();
    this.parsePreferenceData(preference_data);
  }

  /**
   * Parses couse_ids to integers
   */
  normalizeCourseIds() {
    if (this.course_ids) {

      let ids = [];
      for (let id of this.course_ids) {
        ids.push(parseInt(id));
      }

      this.course_ids = ids;
    }
  }

  /**
   * Make a PreferenceData objet
   */
  parsePreferenceData(preferenceData = {}) {
    this.preference_data = {
      itemsTitle: preferenceData.itemsTitle ?? [],
      totalAmount: preferenceData.totalAmount ?? '0.00',
      currency: preferenceData.currency ?? 'BRL',
      formatedPrice: preferenceData.formatedPrice ?? 'R$ 0.00'
    }
  }

  /**
   * Maps status by label
   * 
   * @returns {string}
   */
  mapStatus() {
    if (this.status == this.paymentStatusLabel.CREATED) {
      return this.paymentStatusLabel.PENDING;
    }

    const key = this.status.toUpperCase();
    return this.paymentStatusLabel[key] != undefined 
      ? this.paymentStatusLabel[key] 
      : 'no_status';
  }

  /**
   * Map received payment method
   */
  mapPaymentMethods() {
    return 
  }

  /**
   * Simplifies data of Payment
   */
  simplifyData() {
    return {
      payment_id: this.payment_id,
      status: this.status,
      is_approved: this.is_approved,
      items: this.items,
      items_count: this.items.length,
      raw_date: this.updated_at,
      date: DateHandler.format(this.updated_at, 'DATE_MED'),
      total: this.preference_data.formatedPrice,
      payment_method: this.methodDictionary.getLabel(this.payment_method || ''),
      invoice_available: this.statusDictionary.APPROVED == this.status,
      payer_name: this.payer_name,
      payer_email: this.payer_email,
      product_type: this.product_type
    }
  }
}